import { createStore } from 'vuex'
// 自定义插件
// import history from './plugins/index'

const modules: any = {}

const filesList = require.context('./modules', true, /\.ts$/)
filesList.keys().forEach((route) => {
  if (route.startsWith('./index.ts')) {
    return
  }
  const arr = route.split('/')
  const arr2 = arr[1]?.split('.')
  const apiList = filesList(route)
  modules[arr2[0]] = apiList.default
})
console.log(modules, 'modules')

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules
  // plugins: [history]
})
